import React, { createContext, useContext, useEffect, useRef } from 'react';

const AbortControllerContext = createContext();

export const AbortControllerProvider = ({ children }) => {
    const controllersRef = useRef(new Map());

    // Create a new group if it doesnt exist and set the controller to the group
    const registerController = (group='') => {
        const controller = new AbortController();
        if(!controllersRef.current.has(group)){
            controllersRef.current.set(group, new Set())
        }
        controllersRef.current.get(group).add(controller);
        return controller;
    };

    // Remove the controller from the group and if the group is empty then delete
    const unregisterController = (controller, group='') => {
        if(controllersRef.current.has(group)){
            controllersRef.current.get(group).delete(controller)
            if(controllersRef.current.get(group).size === 0){
                controllersRef.current.delete(group)
            }
        }
    };

    const abortAllRequests = () => {
        controllersRef.current.forEach(groupControllers => {
            groupControllers.forEach(controller => controller.abort())
        });
        controllersRef.current.clear();
    };

    const abortGroupRequests = (group='') => {
        if(controllersRef.current.has(group)){
            controllersRef.current.get(group).forEach(controller => controller.abort());
            controllersRef.current.delete(group);
        }
    };

    const abortSimilarGroupRequests = (group_prefix='') => {
        Array.from(controllersRef.current.keys())
            .filter(group => group.startsWith(group_prefix))
            .forEach(group => {
                controllersRef.current.get(group).forEach(controller => controller.abort());
                controllersRef.current.delete(group);
            });
    }

    return (
        <AbortControllerContext.Provider value={{ abortAllRequests, abortGroupRequests, abortSimilarGroupRequests, registerController, unregisterController }}>
            {children}
        </AbortControllerContext.Provider>
    );
};

// Custom hook to use the context
export const useAbortController = () => useContext(AbortControllerContext);